import actionIconsTemplates from './actionIconsTemplates';

import { DefaultActionIcon, WithCircleActionIcon, NavigationActionIcon, WithTextActionIcon, WithTooltipActionIcon } from './actionIconsLayouts';

const actionIconsSet = [
  {
    component: DefaultActionIcon,
    codeTemplate: actionIconsTemplates.standard,
    optionsGroup: [
      {
        label: 'Standard',
        options: [
          {label: 'Default', type: 'radio', options:{}},
        ]
      },
      {
        label: 'Background:',
        options: [
          {label: 'Light', type: 'radio', options: {bgColor: null, darkBg: false}},
          {label: 'Dark', type: 'radio', options: {bgColor: 'black', darkBg: true}}
        ]
      },
      {
        label: 'Size:',
        options: [
          {label: 'sizes', type: 'dropdown', selectList: [
            {label: '80 px', value: '80px', options: {type: '80'}},
            {label: '40 px', value: '40px', options: {type: '40'}},
            {label: '30 px', value: '30px', options: {type: '30'}},
            {label: '20 px', value: '20px', options: {type: '20'}},
            {label: '15 px', value: '15px', options: {type: '15'}},
            {label: 'navigation', value: 'navigation', options: {type: 'navigation'}},
            {label: 'other', value: 'other', options: {type: 'other'}},
            {label: 'social', value: 'social', options: {type: 'social'}},
          ],
          }
        ]
      }
    ]
  },
  {
    component: WithCircleActionIcon,
    codeTemplate: actionIconsTemplates.withCircle,
    optionsGroup: [
      {
        label: 'With Circle',
        options: [
          {label: 'Large', type: 'radio', options:{large: true}},
          {label: 'Small', type: 'radio', options:{large: false}}
        ]
      },
      {
        label: 'Icon:',
        options: [
          {label: 'Icons', type: 'dropdown', selectList: [
            {label: 'External Page', value: 'external-page', options: {icon: 'external-page', type: '15'}},
            {label: 'More Actions', value: 'more-actions', options: {icon: 'more-actions', type: '15'}},
            {label: 'Search', value: 'search', options: {icon: 'search', type: '15'}},
            {label: 'Selling', value: 'selling', options: {icon: 'selling', type: '15'}},
          ],
          }
        ]
      }
    ]
  },
  {
    component: NavigationActionIcon,
    codeTemplate: actionIconsTemplates.navigation,
    optionsGroup: [
      {
        label: 'Navigation',
        options: [
          {label: 'Default', type: 'radio', options:{exception: false}},
          {label: 'Exceptions', type: 'radio', options:{exception: true}}
        ]
      },
      {
        label: 'Background:',
        options: [
          {label: 'Light', type: 'radio', options: {bgColor: null, darkBg: false}},
          {label: 'Dark', type: 'radio', options: {bgColor: 'black', darkBg: true}}
        ]
      },
      {
        label: 'Icon:',
        options: [
          {label: 'Icons', type: 'dropdown', selectList: [
            {label: 'Menu', value: 'menu', options: {icon: 'menu', type: 'navigation', notifications: null}},
            {label: 'Cart', value: 'cart', options: {icon: 'cart', type: 'navigation', notifications: null}},
            {label: 'User', value: 'user', options: {icon: 'user', type: 'navigation', notifications: null}},
            {label: 'Notifications', value: 'notifications', options: {icon: 'notifications-alert', type: 'navigation', notifications: 8}},
          ],
          }
        ]
      }
    ]
  },
  {
    component: WithTextActionIcon,
    codeTemplate: actionIconsTemplates.withText,
    optionsGroup: [
      {
        label: 'With Text',
        options: [
          {label: 'Large', type: 'radio', options:{large: true}},
          {label: 'Small', type: 'radio', options:{large: false}}
        ]
      },
      {
        label: 'Icon:',
        options: [
          {label: 'Icon:', type: 'dropdown', selectList: [
            {label: 'Back to Top', value: 'back-to-top', options: {icon: 'back-to-top', type: '20', text: 'Back To Top'}},
            {label: 'Mail', value: 'mail', options: {icon: 'mail', type: '20', text: 'Mail'}},
            {label: 'Edit', value: 'edit', options: {icon: 'edit', type: '20', text: 'Edit'}},
            {label: 'Upload', value: 'upload', options: {icon: 'upload', type: '20', text: 'Upload'}},
          ],
          }
        ]
      }
    ]
  },
  {
    component: WithTooltipActionIcon,
    codeTemplate: actionIconsTemplates.withTooltip,
    optionsGroup: [
      {
        label: 'With Tooltip',
        options: [
          {label: 'Default', type: 'radio', options:{}}
        ]
      },
      {
        label: 'Icon:',
        options: [
          {label: 'Icon:', type: 'dropdown', selectList: [
            {label: 'Information', value: 'information', options: {icon: 'information', type: '15'}},
            {label: 'Faqs', value: 'faqs', options: {icon: 'faqs', type: '20'}},
            {label: 'Time', value: 'time', options: {icon: 'time', type: '30'}},
            {label: 'Internet', value: 'internet', options: {icon: 'internet', type: '40'}},
            {label: 'Confirmation', value: 'confirmation', options: {icon: 'confirmation', type: '80'}},
          ],
          }
        ]
      }
    ]
  }
];

export default actionIconsSet;



// WEBPACK FOOTER //
// ./src/containers/elements/ActionIcons/constants/actionIconsSet.js